import { FormattedMessage, FormattedPlural } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import PropTypes from "prop-types";
import "./BaggageInfo.scss";
import { BAGGAGE_TRANSLATION_KEYS } from "app/constants";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const BaggageInfo = ({ baggageList }) => {
	if (!baggageList || baggageList.length === 0) {
		return null;
	}

	const filteredBaggageList = baggageList.filter(baggage => baggage.quantity > 0);

	if (filteredBaggageList.length === 0) {
		return null;
	}

	const renderPrice = baggage => {
		if (baggage?.offered) {
			return (
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="p">
					<FormattedMessage id="general.offered" />
				</Typography>
			);
		}

		if (baggage?.included) {
			return (
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="p">
					<FormattedMessage id="general.included" />
				</Typography>
			);
		}

		return (
			<AmountContainer
				isBold={false}
				prefix={<AmountSign sign="+" />}
				amount={baggage?.price}
				className="baggage-info__value-amount"
			/>
		);
	};

	return (
		<div className="baggage-info" data-testid="baggage-info">
			{filteredBaggageList.map(baggage => {
				return (
					<div
						className="baggage-info__item"
						key={baggage.type}
						data-testid={`baggage-info-${baggage.type}`}
					>
						<div className="baggage-info__label">
							<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="p">
								{baggage.quantity}x{" "}
								<FormattedPlural
									value={baggage.quantity}
									one={
										<FormattedMessage
											id={BAGGAGE_TRANSLATION_KEYS[baggage.type].singular}
											values={{
												count: baggage.quantity,
											}}
										/>
									}
									other={
										<FormattedMessage
											id={BAGGAGE_TRANSLATION_KEYS[baggage.type].plural}
											values={{
												count: baggage.quantity,
											}}
										/>
									}
								/>
							</Typography>

							{baggage?.details && (
								<Typography
									variant={TYPOGRAPHY_VARIANTS.SMALL}
									component="p"
									className="baggage-info__details"
								>
									{typeof baggage.details === "object" && baggage.details.id ? (
										<FormattedMessage
											id={baggage.details.id}
											values={baggage.details.values}
										/>
									) : (
										baggage.details
									)}
								</Typography>
							)}
						</div>

						<div className="baggage-info__value">{renderPrice(baggage)}</div>
					</div>
				);
			})}
		</div>
	);
};

BaggageInfo.propTypes = {
	baggageList: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			quantity: PropTypes.number.isRequired,
			included: PropTypes.bool.isRequired,
			price: PropTypes.number,
		})
	).isRequired,
};

export default BaggageInfo;
